import styled, { css } from "styled-components";
import BaseCard from "ui/common/components/feedback/BaseCard/BaseCard";

export const QrCard = styled(BaseCard)(
    ({ theme }) => css`
        padding: ${theme.spacing.all(10, 8)};
        display: flex;
        justify-content: center;
        border-radius: ${theme.borderRadiusXl};
    `,
);
